import React from 'react';
import sponsorshipBenefitsPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/SPONSORSHIP BENEFITS.pdf';

const ProjectPartners = () => (
	<div className="container main">
		<h2>プロジェクト・パートナー</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<p>
					2012年の開設以来、ポータルをサポートしてくださった以下のパートナーに感謝します。
					2015年から2019年にかけてのポータルの機能強化の概要をまとめた報告書は<a href="https://www.oecd-ilibrary.org/docserver/d8b0d605-en.pdf?expires=1660149598&id=id&accname=guest&checksum=DC849910BFB79841A703E164596516CA">こちら</a>でご覧いただけます。
				</p>
			</div>
			<div className="col-sm-6">
				<p>
					ポータルサイトのサポートにご興味のある団体は、OECD事務局（<a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a>）までご連絡ください。
				</p>
			</div>
		</div>
		<hr/>
		<div className="row partners">
			<div className="col-sm-6">
				<h2>オーストラリア</h2>
				<h4>オーストラリア競争・消費者委員会（ACCC：Australian Competition and Consumer Commission）</h4>
				<p>
					ACCCは、消費者、企業、およびオーストラリアのコミュニティの利益のために、競争、公正な取引、および製品の安全性を促進する独立した法定機関です。
					ACCCの主な責務は、2010年競争・消費者法（CCA）における競争、消費者保護、公正取引、および製品の安全性に関する規定の順守を強化し、国のインフラを規制し、市場調査を実施することです。
				</p>
				<p>
					ACCCは国家の製品安全規制当局として、幅広い必須規格と製品の販売差し止めを管理しています。
					その役割には、オーストラリア全土の消費者に対する最も重大な製品安全リスクを特定し、対処することが含まれます。
					教育や、必要に応じて規制を通して重大なリスクを管理するために、さまざまな戦略を駆使しています。
				</p>
				<img src={require('../../../assets/images/logos/australian.png')} alt=""/>
				<p>
					<a href="http://www.accc.gov.au/content/index.phtml/itemId/54217#top" target="_blank" className="btn btn-info btn-sm">安全に関する懸念を報告</a>
				</p>
				<hr/>

				<h2>ブラジル</h2>
				<h4>ブラジル国家度量衡・規格・工業品質院（Inmetro：Brazilian National Institute of Metrology, Quality and Technology）</h4>
				<p>
					Inmetroは度量衡と品質の国家政策を施行する連邦政府機関です。また、ブラジルの認証機関で、同国における貿易の技術的障害（TBT）に関する中心的な役割を担っています。
				</p>
				<p>
					140種類以上の非食品カテゴリー（リスト：<a href="http://inmetro.gov.br/qualidade/rtepac/compulsorios.asp" target="_blank">http://inmetro.gov.br/qualidade/rtepac/compulsorios.asp</a>）を規制するInmetroは、製品安全性の向上という主要目的のため、適合性評価プログラムを開発しています。
					ブラジルの26州では、消費者を保護し、市場から規格外製品を排除するため、適合性評価プログラムの対象となることが義務付けられた製品を監視しています。
					Inmetroの市場監視活動は、ブラジルの国家基準の重要な変更や、より安全性を高めるための製品設計の変更を特定するのに役立ち、必要に応じて執行措置を取るための技術的基盤を提供します。
				</p>
				<img src={require('../../../assets/images/logos/inmetro.png')} alt=""/>
				<p>
					<a href="https://www.gov.br/inmetro/pt-br/canais_atendimento/ouvidoria/faca-sua-manifestacao" target="_blank" className="btn btn-info btn-sm">安全に関する懸念を報告</a>
				</p>
				<hr/>

				<h2>カナダ</h2>
				<h4>カナダ保健省</h4>
				<p>
					カナダ保健省はカナダ国民の健康の維持・向上を支援するための連邦政府機関です。
					カナダ保健省は全国民の生活改善を目標とし、寿命、ライフスタイル、公共医療制度の効率的活用という尺度からカナダ国民が世界で最も健康的な国民となるよう取り組んでいます。
				</p>
				<p>
					カナダ保健省は規制機関の役割の一環として、国民が日常的に利用する多くの消費者製品や化粧品に伴う健康上のリスクや安全上の問題を調査、評価、共同管理することで国民の保護に貢献しています。
				</p>
				<img src={require('../../../assets/images/logos/canada.png')} alt=""/>
				<p>
					<a href="http://www.healthycanadians.gc.ca/report-signalez/index-eng.php" target="_blank" className="btn btn-info btn-sm">安全に関する懸念を報告</a>
				</p>
				<hr/>

				<h2>メキシコ</h2>
				<h4>メキシコ連邦消費者検察庁（PROFECO）</h4>
				<p>
					メキシコの連邦消費者検察庁（PROFECO）は1976年に設立された政府機関で、行政権を有し、
					サプライヤーと消費者との関係において公平性と合法性を徹底することにより、
					消費者の権利と利益を促進・保護する任務を委ねられています。
				</p>
				<p>
					PROFECOの法的枠組みでは、製品に伴うリスクや、危険あるいは有害とみなされる製品・サービスの提供慣行などから消費者の命と健康、安全を守ることを消費関連の基本原則の1つとしています。
					そのため、PROFECOは付与された権限の範囲で、技術標準の適用の強化と監視を行って製品の安全性と品質を保証すると
					ともに、製品が技術標準に準拠しており、消費者の健康や安全にリスクを及ぼさないことを保証するため、製品の評価に取り組んでいます。
				</p>
				<img src={require('../../../assets/images/logos/profeco.png')} alt=""/>
				<p>
					<a href="https://www.gob.mx/profeco/articulos/proceso-y-requisitos-de-quejas-y-denuncias" target="_blank" className="btn btn-info btn-sm">安全に関する懸念を報告</a>
				</p>
			</div>

			<div className="col-sm-6">
				<h2>欧州委員会</h2>
				<h4>欧州委員会の司法・消費者総局（DG JUST）</h4>
				<p>
					欧州委員会は、EUの全体的な策定を支援し、新しいEUの法律と政策を提案し、その実施状況を監視し、EUの予算を管理します。
				</p>
				<p>
					欧州委員会の司法・消費者総局（DG JUST：Directorate-General for Justice and Consumers）は、EUで販売される消費財の安全確保、EU域内市場における消費者利益の確保、そしてEUの市民の健康と安全の維持と改善を目的として業務を行っています。
				</p>
				<p>
					DG JUSTは、非食品の危険な製品に対する緊急警告システムであるSafety Gateを管理しています。
					このシステムにより、EUおよびEEA諸国の国家当局は、市場で発見された危険な製品に対して講じられた対策に関連するすべての情報を、迅速に相互に流通させることができます。
					その結果、欧州単一市場のあらゆる場所で適切な措置を講じることができます。
				</p>
				<p>
					Safety Gateは、危険とみなされる消費者向けで非食品製品（玩具や化粧品、衣料など）および業務用の製品（電動ドリルや機械、建材など）を対象としています。
					現在、30か国がこのシステムに参加しています（すべてのEU加盟国とEEAおよびEFTA加盟の3か国（ノルウェー、アイスランド、リヒテンシュタイン）。
				</p>
				<p><strong>法的通知</strong></p>
				<p>
					欧州委員会から提供されたデータは、<a href="https://ec.europa.eu/safety-gate-alerts/screen/webReport" target="_blank">Safety Gateのウェブサイト</a>に無料で掲載されています。
				</p>
				<p>
					市場監視を担当する加盟国当局の<a href="https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/Safety_Gate_contacts.pdf" target="_blank">公式窓口</a>は、Safety Gateポータルで公開されている情報を提供します。
					一般製品安全指令（2001/95/EC）の付属書II-10に基づき、提供された情報の責任は通知した当事者に帰属します。
					欧州委員会は、提供される情報の正確性について一切責任を負いません。
				</p>
				<p><strong>警告の再利用</strong></p>
				<p>
					委員会の再利用ポリシーは、欧州委員会文書の再利用に関する2011年12月12日付の欧州委員会決定2011/833/EUで規定されています。
					Safety Gateで公開された情報の再利用は、警告の本来の意味またはメッセージが歪曲されておらず、情報源が認められている場合に許可されます。
				</p>

        {/*Information on reuse of alerts is available here: <a href="https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/New_disclaimer_EN.pdf" target="_blank">https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/New_disclaimer_EN.pdf</a>*/}

				<img src={require('../../../assets/images/logos/european.png')} alt=""/>
				<p>
					<a href="mailto:Sanco-Reis@ec.europa.eu" target="_blank" className="btn btn-info btn-sm">安全に関する懸念を報告</a>
				</p>
				<hr/>

				<h2>アメリカ</h2>
				<h4>米国消費者製品安全委員会（CPSC：Consumer Product Safety Commission）</h4>
				<p>
					米国消費者製品安全委員会（CPSC）は管轄下にある数千種類もの消費者製品が引き起こす傷害や死亡事故など不合理なリスクから消費者を保護する義務があります。
					CPSCは、火災のおそれや電気的、化学的、機械的な危険性を伴う、または子供の怪我につながる可能性がある製品から消費者や家族を守ることに取り組んでいます。
					CPSCは、玩具やベビーベッド、電動工具、タバコ用ライター、家庭用化学品などの消費者製品の安全性確保に努めており、その取り組みが奏功して1973年の活動開始以降、消費者製品に関連する死亡や傷害事故の発生率が減少し続けています。
				</p>
				<img src={require('../../../assets/images/logos/us.png')} alt=""/>
				<p>
					<a href="http://www.saferproducts.gov/" target="_blank" className="btn btn-info btn-sm">安全に関する懸念を報告</a>
				</p>
				<hr/>

				<h2>GS1</h2>
				<p>
					GS1は中立的な非営利目的の国際機関で、全産業にわたるサプライチェーンの効率とビジビリティの向上を目的として国際規格の策定とソリューションの開発を行っています。
					GS1は貿易相手国、業界団体、技術提供者などグローバルなコミュニティと連携し、ビジネスニーズを理解して、
					それらに対応した国際規格を策定しています。
					GS1は、小売・消費者製品、ヘルスケア、輸送・物流など20業種以上の200万近いユーザー組織を擁しており、現在、
					GS1システムは世界で最も幅広く採用されているサプライチェーンの規格体系です。
					GS1の加入組織は110カ国以上にあり、本部はブリュッセルに置かれています。詳しくは<a href="http://www.gs1.org" target="_blank">www.gs1.org</a>をご覧ください。
				</p>
				<img src={require('../../../assets/images/logos/gs1.png')} alt=""/>
			</div>
		</div>
	</div>
);

export default ProjectPartners;



// WEBPACK FOOTER //
// ./src/views/static/ja/project-partners.js